"use client";
import { toast as sonnerToast } from 'sonner';

function toast({ title, description, variant, ...props }) {
  if (variant === 'destructive') {
    return sonnerToast.error(title || 'Error', { description });
  }
  return sonnerToast.success(title || 'Success', { description });
}

function useToast() {
  return {
    toast,
    toasts: [],
    dismiss: (toastId) => sonnerToast.dismiss(toastId),
  };
}

export { useToast, toast };
